/**
 * Remove idd prefix from phone number
 * @see https://en.wikipedia.org/wiki/List_of_international_call_prefixes
 */
export function phoneWithoutIdd(phoneNumber: string): string {
  if (!phoneNumber) {
    return phoneNumber;
  }

  phoneNumber = phoneNumber.startsWith('00') ? phoneNumber.replace('00', '') : phoneNumber;
  phoneNumber = phoneNumber.startsWith('+') ? phoneNumber.replace('+', '') : phoneNumber;

  return phoneNumber;
}
